export enum RoutePrefix {
  USER_PROFILE = 'user-profile',
  SHOP_SETTINGS = 'shop-settings',
}
